import React, {useContext, useState} from "react";
import {useTranslation} from "react-i18next";
//@ts-ignore
import _ from "lodash";

import {Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import {AppContext} from "src/pages/context/App.context";
import useFetch, {CachePolicies} from "use-http";
import {UserAPIEndpoint} from "src/service/user.service";
import CenterConfirmModal from "src/components/shared/Modal/CenterConfirmModal";

function UIModalConfirmBlock(props: any) {
  const { t, i18n } = useTranslation();
  const [loading, setLoading]: any = useState(false);
  const [messageNoti, setMessageNoti]: any = useState("");
  const appcontext: any = useContext(AppContext);
  const { onClose, friend, onRefresh, onCloseProfilePopup } = props;

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: "#FFFFFF" }} spin />
  );

  const apiBlock = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + UserAPIEndpoint.BlockFriend,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const fnDone = async () => {
    let data = {
      friendID: friend.id,
    };
    const res = await apiBlock.post("", data);
    appcontext?.setTiggerLoadFriends(appcontext.tiggerLoadFriends + 1);
    onClose();
    onRefresh?.();
    onCloseProfilePopup();
  };

  return (
    <CenterConfirmModal
      cancelText={"Cancel"}
      confirmText={apiBlock.loading ? <Spin indicator={antIcon} /> : t("Ok")}
      text={
        "Blocked contacts will no longer be able to call you or send you message"
      }
      visible={true}
      onCancel={() => {
        onClose();
      }}
      onConfirm={() => {
        fnDone();
      }}
    ></CenterConfirmModal>
    // <Modal
    //   // centered
    //   visible={true}
    //   className={styles.modalOveride}
    //   onCancel={() => {
    //     // appcontext.setShowConfirmBlock(false);
    //     onClose()
    //   }}
    //   closeIcon={<div />}
    //   closable={false}
    // >
    //   <div className={styles.boxCreate}>
    //     <div style={{ fontSize: "1.3rem", fontWeight: "bold" }}>
    //       {t("Block")}
    //     </div>

    //     <div style={{ fontSize: "1rem", color: "#5f5f5f" }}>
    //       {t(
    //         "Blocked contacts will no longer be able to call you or send you message."
    //       )}
    //     </div>

    //     <div className={styles.boxConfirmBtn}>
    //       <button
    //         className={styles.bottonBtnCancel}
    //         style={{ fontSize: "1.2rem", marginTop: "39px" }}
    //       >
    //         <div
    //           onClick={() => {
    //             if (loading === false) {
    //               // appcontext.setShowConfirmBlock(false);
    //               onClose()
    //             }
    //           }}
    //         >
    //           {t("Cancel")}
    //         </div>
    //       </button>
    //       <button
    //         className={styles.bottonBtnOk}
    //         style={{ fontSize: "1.2rem", marginTop: "39px" }}
    //       >
    //         <div onClick={fnDone}>
    //           {apiBlock.loading ? <Spin indicator={antIcon} /> : t("Block")}
    //         </div>
    //       </button>
    //     </div>
    //   </div>
    // </Modal>
  );
}

export default UIModalConfirmBlock;
